export default "__VITE_ASSET__97dfdca8__"